import angular from "angular";
import { AdpConfigEditorComponent } from "./adp-config-editor.component";
import { AdpEarningsCodeEditorComponent } from "./adp-earnings-code-editor.component";
import { AdpEarningsFieldEditorComponent } from "./adp-earnings-field-editor.component";

export const AdpConfigEditorModule = angular
    .module('apex.adpConfig.editor', [])
    .component("apexAdpConfigEditor", AdpConfigEditorComponent)
    .component("apexAdpEarningsCodeEditor", AdpEarningsCodeEditorComponent)
    .component("apexAdpEarningsFieldEditor", AdpEarningsFieldEditorComponent)
    .name;
